export default "__VITE_ASSET__CMN8P1jA__"